// @ts-check

import {
  A11y,
  Swiper,
  Lazy,
  Navigation,
  Pagination,
} from 'swiper';

Swiper.use([A11y, Lazy, Navigation, Pagination]);

window['mainSlider'] = () => {
    return new Swiper('.main-slider', {
      a11y: { enabled: true },
      speed: 600,
      spaceBetween: 0,
      slidesPerView: 1,
      preventClicks: false,
      loop: false,
      centeredSlides: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      // Disable preloading of all images
      preloadImages: false,
      // Enable lazy loading
      lazy: {
        checkInView: true,
      },
    });
};

window['mainSlider']();
new Swiper('.home-banner-sliders', {
    a11y: { enabled: true },
    spaceBetween: 20,
    slidesPerView: 1.35,
    breakpoints: {
      724: {
        slidesPerView: 2.5,
        spaceBetween: 5
      },
      1264: {
        slidesPerView: 3,
        spaceBetween: 5
      },
    }
  });

new Swiper('.villas-slider', {
  a11y: { enabled: true },
  speed: 600,
  spaceBetween: 0,
  slidesPerView: 1,
  preventClicks: false,
  loop: true,
  centeredSlides: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }
});

new Swiper('.sleeping-arrangements', {
  a11y: { enabled: true },
  spaceBetween: 12,
  slidesPerView: 2.15,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true
  },
  breakpoints: {
    724: {
      slidesPerView: 2.5,
      spaceBetween: 5
    },
    1264: {
      slidesPerView: 3,
      spaceBetween: 5
    },
  }
});

document.querySelectorAll('.service-slider').forEach((el) => {
  new Swiper(el, {
    a11y: { enabled: true },
    spaceBetween: 20,
    slidesPerView: 1.35,
    breakpoints: {
      724: {
        slidesPerView: 2.5,
        spaceBetween: 5
      },
      1264: {
        slidesPerView: 3,
        spaceBetween: 5
      },
    }
  });
});
